const _map: Array<{ sourceType: number; collectType: number; label?: string }> = [
  { sourceType: 1, collectType: 11, label: '备展日记' },
  { sourceType: 2, collectType: 21, label: '备展花絮' },
  { sourceType: 3, collectType: 31, label: '晒作业' },
  { sourceType: 4, collectType: 2, label: '文墨可爱' },
  { sourceType: 5, collectType: 3, label: '暄桐雅会' },
  { sourceType: 6, collectType: 4, label: '出版物' },
  { sourceType: 7, collectType: 7, label: '公开课' },
  { sourceType: 8, collectType: 8, label: '参展作品' },
]

/**
 * 根据moment详情中的sourceType映射为收藏接口中的collectType
 * @param sourceType
 */
export function mapCollectType(sourceType: number) {
  const item = _map.find(i => i.sourceType === sourceType)

  if (item) {
    return item.collectType
  }

  // never!!
  return -1
}
